// togglebutton created with initButtonToggle are querystring aware, meaning it will default to the state that the querystring. Requires the pointableSelector elements to have ID's.

define(['jquery'], function ($) {
    var isInitialTransform = true;
    var toggleSwitch = {
        //use when widget is based on button html element (see example on localplanlistpage)
        initButtonToggle: function (pointableSelector, selectedOptionSelector, pointerElementSelector, switchContainerSelector, callbackOnChange, queryStrPrm) {
            if (pointableSelector.length > 0 && selectedOptionSelector.length > 0 && pointerElementSelector.length > 0) {

                var $toggleSwitchContainer = $(switchContainerSelector);

                //click event for toggle elements
                $toggleSwitchContainer.find(pointableSelector).click(function () {
                    toggleSwitch.transformToggleSwitchPointer($(this), pointerElementSelector, pointableSelector, $toggleSwitchContainer);
                    //initial transform triggers change/click, 
                    //this prevents a callback on first page load
                    if (callbackOnChange != undefined) {
                        callbackOnChange();
                    }
                });

                //initial transform
                // look for what element to set as active. fallback to configured
                const urlSearchParams = new URLSearchParams(window.location.search);
                const defaultElement = urlSearchParams.get(queryStrPrm);
                const elementToGoTo = $toggleSwitchContainer.find( (defaultElement ? '#' + defaultElement : selectedOptionSelector));
                this.transformToggleSwitchPointer(elementToGoTo, pointerElementSelector, pointableSelector, $toggleSwitchContainer);

                this.addResizeListener(selectedOptionSelector, false, pointerElementSelector, pointableSelector, $toggleSwitchContainer);
            }
        },
        //use when widget is based on checkbox html element (see example on insidenewslistpage)
        initCheckboxToggle: function (pointableSelector, pointerElementSelector, switchContainerSelector) {

            if (pointableSelector.length > 0 && pointerElementSelector.length > 0) {

                var $toggleSwitchContainer = $(switchContainerSelector);

                $toggleSwitchContainer.find('input[type=radio][name=newstype-toggleswitch]').change(function () {
                    var $clickedElement = $(this);
                    var $label = $toggleSwitchContainer.find("label[for='" + $clickedElement.attr('id') + "']");
                    toggleSwitch.transformToggleSwitchPointer($label, pointerElementSelector, pointableSelector, $toggleSwitchContainer);
                });

                this.addResizeListener("", true, pointerElementSelector, pointableSelector, $toggleSwitchContainer);

                //initial check and transform for which toggle switch element is checked
                var $checkedElement = $toggleSwitchContainer.find('input[type=radio][name=newstype-toggleswitch]:checked');
                var $label = $toggleSwitchContainer.find("label[for='" + $checkedElement.attr('id') + "']");
                this.transformToggleSwitchPointer($label, pointerElementSelector, pointableSelector, $toggleSwitchContainer);
            }
        },
        //position the element that marks the currently chosen option for the toggle switch
        transformToggleSwitchPointer: function ($pointToElement, pointerElementSelector, pointableSelector, $toggleSwitchContainer) {
            //transform and position pointer element
            var $pointerElement = $toggleSwitchContainer.find(pointerElementSelector);

            //check that elements for toggle-switch is present on page
            var pointerElementPresentOnPage = $pointerElement.length > 0;
            var pointToElementPresentOnPage = $pointToElement.length > 0;

            if (pointToElementPresentOnPage && pointerElementPresentOnPage) {

                var checkedInputPos = $pointToElement.position().left - 4;
                $pointerElement.css({
                    "min-width": $pointToElement.outerWidth() + "px",
                    "transform": "translateX(" + checkedInputPos + "px)"
                });

                toggleSwitch.updateActiveClasses($pointToElement, pointableSelector, $toggleSwitchContainer);
            }
        },
        //update toggle-switch when window is resized
        addResizeListener: function (selectedOptionSelector, widgetIsBasedOnCheckbox, pointerElementSelector, pointableSelector, $toggleSwitchContainer) {

            // Register event listener to trigger js positioning of toggle switch pointer
            // setTimeout to limit number of times it runs
            var debounceFunction;
            $(window).on('resize', function () {
                clearTimeout(debounceFunction);
                debounceFunction = setTimeout(function () {
                    var $selectedOption = $toggleSwitchContainer.find(selectedOptionSelector);

                    //for cases when a checkbox element is used
                    if (widgetIsBasedOnCheckbox) {
                        var $checkedElement = $toggleSwitchContainer.find('input[type=radio][name=newstype-toggleswitch]:checked');
                        var $label = $toggleSwitchContainer.find("label[for='" + $checkedElement.attr('id') + "']");
                        toggleSwitch.transformToggleSwitchPointer($label, pointerElementSelector, pointableSelector, $toggleSwitchContainer);
                    }
                    else if ($selectedOption.length > 0) {
                        toggleSwitch.transformToggleSwitchPointer($selectedOption, pointerElementSelector, pointableSelector, $toggleSwitchContainer);
                    }
                }, 100);
            });

        },
        updateActiveClasses: function ($activeElement, pointableSelector, $toggleSwitchContainer) {

            var $toggleElements = $toggleSwitchContainer.find(pointableSelector);
            for (var i = 0; i < $toggleElements.length; i++) {
                $toggleElements[i].setAttribute('aria-selected', 'false');
                $toggleElements[i].classList.remove("active");
            }
            $activeElement.attr('aria-selected', 'true'); //set aria-selected=true for clicked element
            $activeElement.addClass('active');
        }
    }

    return toggleSwitch;
});